import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';

export class TextChangeCommand extends ShapeCommand {
  services: any;
  original;
  modified;
  constructor(data, modifications) {
    super(data);
    this.original = _.cloneDeep(data);
    this.modified = _.assign(_.cloneDeep(data), modifications);
  }

  changeTextRequest(data) {
    const keys = ['mxKey', 'number', 'text', 'position', 'link', 'lock'];
    const payload = _.pick(data, keys);

    return this.services.diagramUpdateSvc.update({
      changeText: payload
    });
  }

  public execute() {
    super.execute();

    return this.changeTextRequest(this.modified);
  }

  public reverse() {
    super.reverse();

    return this.changeTextRequest(this.original);
  }
}
